const entity = {
  urls: {
    index: '/testimonies',
    link: document => `/testimony/${document.uid}`
  },
  labels: {
    singular: 'getuigenis',
    singularAlt: 'Getuigenis',
    plural: 'getuigenissen',
    pluralAlt: 'Getuigenissen'
  }
}

exports.entity = entity

exports.getHeadline = meta => ({
  meta,
  link: {
    text: `alle ${entity.labels.plural}`,
    url: entity.urls.index
  }
})

exports.create = async (graphql, createPage, wrapper) => {
  createPage({
    path: entity.urls.index,
    component: require.resolve('./page.jsx')
  })

  const result = await wrapper(
    graphql(`
      {
        allPrismicTestimony {
          edges {
            node {
              uid
            }
          }
        }
      }
    `)
  )

  result.data.allPrismicTestimony.edges.forEach(edge => {
    const uid = edge.node.uid

    createPage({
      path: entity.urls.link(edge.node),
      component: require.resolve('./template.jsx'),
      context: { uid }
    })
  })
}
